import { Component, HostListener, OnInit, inject } from '@angular/core';
import { SiderbarComponent } from '../siderbar/siderbar.component';
import { RouterOutlet } from '@angular/router';
import { InactiveService } from '../../services/inactive.service';
import { AuthService } from '../../services/auth/auth.service';
import { MobileHeaderComponent } from '../connects/mobile-header/mobile-header.component';
import { NavBarComponent } from '../nav-bar/nav-bar.component';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss',
  imports: [
    SiderbarComponent,
    RouterOutlet,
    MobileHeaderComponent,
    NavBarComponent,
  ],
})
export class MainLayoutComponent implements OnInit {
  private readonly inactiveService = inject(InactiveService);
  private readonly authService = inject(AuthService);

  @HostListener('document:mousemove', ['$event'])
  @HostListener('document:click', ['$event'])
  @HostListener('document:scroll', ['$event'])
  @HostListener('document:keypress', ['$event'])
  userActivity() {
    this.inactiveService.startTimer();
  }

  ngOnInit(): void {
    this.inactiveService.startTimer();

    this.inactiveService.onInactivity().subscribe(() => {
      this.authService.logout();
    });
  }
}
